import { Container, Divider, Fade, Stack } from '@mui/material';
import React from 'react';
import LogoBSRE from '../LogoBSRE';

const LandingPartner = () => {
  const component = (
    <Container maxWidth="md">
      <Fade in="true" timeout={1500}>
        <Stack mt={4}>
          <Divider style={{ marginBottom: 10 }} />
          <LogoBSRE sx={{ width: 150 }} />
        </Stack>
      </Fade>
    </Container>
  );
  return component;
};

export default LandingPartner;
